import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "quotes-wrapper" }
const _hoisted_2 = { class: "grid justify-content-center ml-0" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2 table-wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "p-0 m-0" }, "Add To Cart Items", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-0 m-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-xl text-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-warning mr-2 text-3xl" }),
    /*#__PURE__*/_createTextVNode("There are items in the current order")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-lg text-center" }, "What would you like to do with the current order?")
], -1)
const _hoisted_6 = { class: "p-0 m-0 pt-2" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "field-checkbox align-items-start mt-3 mb-2 pl-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "show-model-number" }, "Show Model Number", -1)
const _hoisted_10 = { class: "field-checkbox align-items-start ml-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "show-prices" }, "Show Prices", -1)
const _hoisted_12 = { class: "flex justify-content-end p-0 m-0" }
const _hoisted_13 = { class: "p-0 m-0" }
const _hoisted_14 = { class: "p-0 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SendOrderDialog = _resolveComponent("SendOrderDialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_NotificationCard = _resolveComponent("NotificationCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Card, { class: "col-11 mb-5 mt-3" }, {
          content: _withCtx(() => [
            _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoadingSoQuotes }, null, 8, ["loading"]),
            (!_ctx.isLoadingSoQuotes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_DataGrid, {
                    items: _ctx.soQuotes,
                    columns: _ctx.columns,
                    breakpoint: "1267px",
                    dataKey: "id",
                    actions: _ctx.tableActions,
                    selectionMode: "single",
                    filters: _ctx.filters,
                    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters) = $event)),
                    onOnPageClicked: _ctx.pageClick,
                    onOnSort: _ctx.sortQuotes,
                    sortField: _ctx.sort.sortBy,
                    sortOrder: _ctx.sort.sortOrder,
                    onFetchData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateFilters($event))),
                    onSelectRow: _ctx.rowClick
                  }, null, 8, ["items", "columns", "actions", "filters", "onOnPageClicked", "onOnSort", "sortField", "sortOrder", "onSelectRow"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Footer),
    _createVNode(_component_Dialog, {
      visible: _ctx.showReorderConfirmation,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showReorderConfirmation) = $event)),
      modal: "",
      class: "w-6 xl:w-4"
    }, {
      header: _withCtx(() => [
        _hoisted_4
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            label: "Replace Parts",
            icon: "pi pi-undo",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClearAndReorderItems(_ctx.addingReorderItems)))
          }),
          _createVNode(_component_Button, {
            label: "Add Parts",
            icon: "pi pi-plus",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleReorderItems(_ctx.addingReorderItems)))
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_SendOrderDialog, {
      title: `Send quote ${_ctx.quoteIdToSend} by email`,
      visible: _ctx.showEmailPDFDialog,
      orderId: _ctx.quoteIdToSend,
      "show-models-checkbox": _ctx.showModelsCheckboxOnDialog,
      "show-prices-checkbox": _ctx.showPricesCheckboxOnDialog,
      loading: _ctx.emailLoading,
      onOnCloseDialog: _ctx.closeSendEmailDialog,
      onOnSendEmail: _ctx.handleSendEmail
    }, null, 8, ["title", "visible", "orderId", "show-models-checkbox", "show-prices-checkbox", "loading", "onOnCloseDialog", "onOnSendEmail"]),
    _createVNode(_component_Dialog, {
      header: "Download Options",
      visible: _ctx.showPDFOptionsDialog,
      modal: true,
      closable: false,
      class: "w-11 md:w-6 lg:w-4 xl:w-3"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Button, {
              label: "Cancel",
              icon: "pi pi-times",
              class: "p-button-text",
              style: {color: '#FFF'},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPDFOptionsDialog = false))
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              label: "Download",
              onClick: _ctx.onPDFOptionDialogClosed
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Checkbox, {
              id: "show-model-number",
              modelValue: _ctx.showModelsSelection,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModelsSelection) = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Checkbox, {
              id: "show-prices",
              modelValue: _ctx.showPricesSelection,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showPricesSelection) = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _hoisted_11
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_NotificationCard)
  ], 64))
}